export default __webpack_public_path__ + "static/media/cinemasearch.013b9a2b.gif";